import React from "react";
import style from "./index.module.scss";
import Header from "../../../components/Header";
import MyStore from "../MyStore";

export default function Index() {
    return (
        <div className={style.root}>
            <Header navIsShow={false} />
            <div className={style.pd}>
                <MyStore />
            </div>
        </div>
    );
}
